import { MutableRefObject, JSX } from 'react';
import { Modal } from '@bg-components/Modal';
import { ModalContent } from '@bg-components/Modal/ModalContent';
import { QuestionIcon } from '@bg-components/Icon';
import { HowToPlay, HowToPlaySkeleton } from '@bg-components/HowToPlay';
import { PagesModalHeader } from '@bg-components/Modals/components/PagesModalHeader';
import { LazyRoute } from '@bg-components/LazyRoute';
import { fadeAnimation } from '@bg-components/Modals/constants/fadeAnimation';
import { IModalProps, ModalName, t } from '@bg-shared';
import classes from './HowToPlayModal.module.scss';

interface IProps extends IModalProps {
    openerElementRef?: MutableRefObject<HTMLElement>;
}

export const HowToPlayModal = (props: IProps): JSX.Element => (
    <Modal
        modalName={ModalName.HOW_TO_PLAY}
        onClose={props.onClose}
        animation={fadeAnimation}
        openerElementRef={props.openerElementRef}
        className={classes.modal}
    >
        <PagesModalHeader
            title={t.string('how_to_play')}
            icon={QuestionIcon}
            onClose={props.onClose}
        />
        <ModalContent>
            <LazyRoute Fallback={<HowToPlaySkeleton />}>
                <HowToPlay />
            </LazyRoute>
        </ModalContent>
    </Modal>
);
